module.exports = __webpack_public_path__ + "img/magnifying-glass-solid.9db37acf.svg";